import { render, staticRenderFns } from "./classifyList.vue?vue&type=template&id=dbaf9164&scoped=true"
import script from "./classifyList.vue?vue&type=script&lang=js"
export * from "./classifyList.vue?vue&type=script&lang=js"
import style0 from "./classifyList.vue?vue&type=style&index=0&id=dbaf9164&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbaf9164",
  null
  
)

export default component.exports